import { useState } from "react";
import { Mail, ChevronUp, ChevronDown } from "lucide-react";

export default function SourceEmailPanel({ subject, from, date, body }) {
  const [open, setOpen] = useState(false);
  const dateLabel = date
    ? new Date(date).toLocaleString("en-IN", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "";
  return (
    <div className="mt-3 rounded-md border border-amber-200 bg-amber-50/40 overflow-hidden" data-testid="ic-source-email">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid="ic-source-email-toggle"
        className="w-full px-3 py-2 flex items-center gap-2 text-left hover:bg-amber-50 pointer-events-auto"
      >
        <Mail className="w-3.5 h-3.5 text-amber-700 flex-shrink-0" />
        <span className="text-[10.5px] uppercase font-bold text-amber-700 tracking-wide flex-shrink-0">Source email</span>
        <span className="text-[12px] text-zinc-800 font-medium truncate flex-1" title={subject}>{subject || "(no subject)"}</span>
        {from && <span className="text-[10.5px] text-zinc-500 truncate hidden sm:block max-w-[180px]" title={from}>{from}</span>}
        {dateLabel && <span className="text-[10px] text-zinc-400 hidden md:block flex-shrink-0">{dateLabel}</span>}
        {open ? <ChevronUp className="w-3.5 h-3.5 text-amber-700" /> : <ChevronDown className="w-3.5 h-3.5 text-amber-700" />}
      </button>
      {open && (
        <div className="px-3 pb-3 border-t border-amber-200 bg-white" data-testid="ic-source-email-body">
          {(from || dateLabel) && (
            <div className="text-[10.5px] text-zinc-500 pt-2 pb-1 flex flex-wrap gap-x-3">
              {from && <span><b className="text-zinc-700">From:</b> {from}</span>}
              {dateLabel && <span><b className="text-zinc-700">Sent:</b> {dateLabel}</span>}
            </div>
          )}
          <div className="max-h-[260px] overflow-y-auto bg-zinc-50/80 border border-zinc-100 rounded p-2.5 mt-1">
            <p className="text-[11.5px] text-zinc-800 whitespace-pre-line leading-relaxed">
              {body || "(No body captured for this email)"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
